import React, { useEffect, useState } from 'react';
import './infoProfesional.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faMailReply, faPenSquare } from '@fortawesome/free-solid-svg-icons'

const InfoProfesional = () => {

    const prefijosN1 = [
        { value: 'pN1V1', label: 'Dr. — Doctor' },
        { value: 'pN1V2', label: 'Dra. — Doctora' },
        { value: 'pN1V3', label: 'Enf. — Enfermero(a)' },
        { value: 'pN1V4', label: 'Lic. — Licenciado/a' },
        { value: 'pN1V5', label: 'Nut. — Nutricionista' },
        { value: 'pN1V6', label: 'Fisio. — Fisioterapeuta' },
        { value: 'pN1V7', label: 'Psic. — Psicólogo(a)' },
        { value: 'pN1V8', label: 'Od. — Odontólogo(a)' },
        { value: 'pN1V9', label: 'Tec. — Técnico/a en salud' },
        { value: 'pN1V10', label: 'Aux. — Auxiliar' },
        { value: 'pN1V11', label: 'Ter. — Terapeuta' },
        { value: 'pN1V12', label: 'Coach — Entrenador / Coach' },
        { value: 'OTRO', label: 'Otro' },
    ]

    const prefijosN2 = [
        { value: 'pN2V1', label: 'Est. — Esteticista' },
        { value: 'pN2V2', label: 'Cosm. — Cosmetólogo(a)' },
        { value: 'pN2V3', label: 'Barb. — Barbero' },
        { value: 'pN2V4', label: 'Maqu. — Maquillador(a)' },
        { value: 'pN2V5', label: 'Stylist' },
        { value: 'pN2V6', label: 'Master (típico en barbería o uñas)' },
        { value: 'OTRO', label: 'Otro' },
    ]

    const prefijosN3 = [
        { value: 'PN3N1', label: 'MVZ. — Médico Veterinario Zootecnista' },
        { value: 'pN3V2', label: 'Dr. — Doctor' },
        { value: 'pN3V3', label: 'Dra. — Doctora' },
        { value: 'pN3V4', label: 'Enf. — Enfermero(a)' },
        { value: 'pN3V5', label: 'Lic. — Licenciado/a' },
        { value: 'pN3V6', label: 'Nut. — Nutricionista' },
        { value: 'pN3V7', label: 'Fisio. — Fisioterapeuta' },
        { value: 'pN3V8', label: 'Psic. — Psicólogo(a)' },
        { value: 'pN3V9', label: 'Od. — Odontólogo(a)' },
        { value: 'pN3V10', label: 'Tec. — Técnico/a en salud' },
        { value: 'pN3V11', label: 'Aux. — Auxiliar' },
        { value: 'pN3V12', label: 'Ter. — Terapeuta' },
        { value: 'pN3V13', label: 'Coach — Entrenador / Coach' },
        { value: 'OTRO', label: 'Otro' },
    ]

    const [vistaInfoProfesional, setVistaInfoProfesional] = useState('VISTA_DETALLE_INFO_PROFESIONAL')
    const [tipoNegocio, setTipoNegocio] = useState('')

    const [activaFaceBook, setActivaFaceBook] = useState(false)
    const [activaInstagram, setActivaInstagram] = useState(false)
    const [activaLinkedin, setActivaLinkedin] = useState(false)

    useEffect(() => {
        let usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage)
            setTipoNegocio(usuarioLocalStorageObj.tipoDeNegocio)
        }
    }, [])

    const [formStateValue, setformStateValue] = useState({
        nombreProfesional: '0',
        otroNombreProfesional: '',
        profesionOficio: '',
        especialidadAreaServicio: '',
        cotactoProfesional1: '',
        cotactoProfesional2: '',
        cotactoProfesional3: '',
    })

    const [formState, setformState] = useState({
        nombreProfesionalRef: false,
        otroNombreProfesionalRef: false,
        profesionOficioRef: false,
        especialidadAreaServicioRef: false,
        cotactoProfesional1Ref: false,
        cotactoProfesional2Ref: false,
        cotactoProfesional3Ref: false,
    })

    const {
        nombreProfesional,
        otroNombreProfesional,
        profesionOficio,
        especialidadAreaServicio,
        cotactoProfesional1, cotactoProfesional2, cotactoProfesional3 } = formStateValue;

    const {
        nombreProfesionalRef,
        otroNombreProfesionalRef,
        profesionOficioRef,
        especialidadAreaServicioRef,
        cotactoProfesional1Ref, cotactoProfesional2Ref, cotactoProfesional3Ref } = formState;

    const changeInput = (e) => {
        setformStateValue({
            ...formStateValue,
            [e.target.name]: e.target.value
        })
    }

    const menuSelectPrefijosProfesionales = () => {
        switch (tipoNegocio) {
            case 'NEGOCIO_1':
                return (
                    <>
                        {

                            prefijosN1.map((key, i) => {
                                return (
                                    <option key={i} value={key.value}>{key.label}</option>
                                )
                            })
                        }
                    </>
                )
            case 'NEGOCIO_2':
                return (
                    <>
                        {

                            prefijosN2.map((key, i) => {
                                return (
                                    <option key={i} value={key.value}>{key.label}</option>
                                )
                            })
                        }
                    </>
                )
            case 'NEGOCIO_3':
                return (
                    <>
                        {

                            prefijosN3.map((key, i) => {
                                return (
                                    <option key={i} value={key.value}>{key.label}</option>
                                )
                            })
                        }
                    </>
                )
            default:
                return (
                    <></>
                )
        }
    }

    const slectVistaEditarInfoProfesional = () => {
        switch (vistaInfoProfesional) {
            case 'VISTA_DETALLE_INFO_PROFESIONAL':
                return (
                    <>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                                <div className='div-actionperfil-profesional'>
                                    <h1 className='size-db-info-perfil-h1 mb-2'>
                                        Información Profesional:
                                    </h1>
                                    <button className='btn btn-link a-link-blue' onClick={() => setVistaInfoProfesional('VISTA_EDITAR_INFO_PROFESIONAL')}>
                                        <FontAwesomeIcon className='' icon={faPenToSquare} />
                                        Editar
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                                <div className="col-12 col-sm-12 col-md-6 col-lg-4" >
                                    <div className='div-form'>
                                        <p className='p-label-form'> Profesión u oficio: </p>
                                        <p> {''} </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                                <div className="col-12 col-sm-12 col-md-6 col-lg-4" >
                                    <div className='div-form'>
                                        <p className='p-label-form'> Especialidad: </p>
                                        <p> {''} </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                                <div className='div-form'>
                                    <p className='p-label-form'>Contacto profesional: </p>
                                    <p>{''} </p>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                                <div className='div-form'>
                                    <p className='p-label-form'> Descripción profesional / Bio: </p>
                                    <p>{''} </p>
                                </div>
                            </div>
                        </div>
                    </>
                )
            case 'VISTA_EDITAR_INFO_PROFESIONAL':
                return (
                    <>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                                <div className='div-actionperfil-profesional'>
                                    <h1 className='size-db-info-perfil-h1 mb-2'>
                                        Información Profesional:
                                    </h1>
                                    <button className='btn btn-link a-link-blue' onClick={() => setVistaInfoProfesional('VISTA_DETALLE_INFO_PROFESIONAL')}>
                                        <FontAwesomeIcon className='' icon={faMailReply} />
                                        Volver
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 my-2" >
                                <div className=''>
                                    <p className='p-label-info-text'>Título profesional / Tratamiento:</p>
                                    <select name='nombreProfesional' className={nombreProfesionalRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                        value={nombreProfesional} onChange={changeInput}>
                                        <option value='0'>Seleccione</option>
                                        {
                                            menuSelectPrefijosProfesionales()
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 my-2" >
                                {
                                    nombreProfesional === 'OTRO' ?
                                        <div className=''>
                                            <p className='p-label-info-text'>Especifique título profesional / Tratamiento:</p>
                                            <input type="text" name='otroNombreProfesional' className={otroNombreProfesionalRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                                value={otroNombreProfesional} onChange={changeInput} />
                                        </div>
                                        :
                                        <></>
                                }
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 my-2" >
                                <div className=''>
                                    <p className='p-label-info-text'>Profesión u oficio:</p>
                                    <input type="text" name='profesionOficio' className={profesionOficioRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                        value={profesionOficio} onChange={changeInput} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 my-2" >
                                <div className=''>
                                    <p className='p-label-info-text'>Especialidad / área de servicio:</p>
                                    <input type="text" name='especialidadAreaServicio' className={especialidadAreaServicioRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                        value={especialidadAreaServicio} onChange={changeInput} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 my-2" >
                                <div className=''>
                                    <p className='p-label-info-text'>Contacto profesional:</p>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6" ></div>
                            <div className="col-12 col-sm-12 col-md-1 col-lg-1" ></div>
                            <div className="col-12 col-sm-12 col-md-10 col-lg-10" >
                                <div className='div-contacto-profesional-note'>
                                    <p className='p-label-info-text'>Facebook:</p>
                                    <div className='div-contacto-profesional-note-hijo'>
                                        {
                                            activaFaceBook ?
                                                <>
                                                    <input type="text" name='cotactoProfesional1' className={cotactoProfesional1Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                                        value={cotactoProfesional1} onChange={changeInput} />
                                                </>
                                                :
                                                <>
                                                    <input type="text" name='cotactoProfesional1' className={cotactoProfesional1Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                                        value={cotactoProfesional1} onChange={changeInput} disabled />
                                                </>
                                        }
                                        <div className={activaFaceBook ? "div-slide-padre-active" : "div-slide-padre"} onClick={() => setActivaFaceBook(!activaFaceBook)} >
                                            <div className={activaFaceBook ? "div-slide-hijo-active" : "div-slide-hijo"}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-1 col-lg-1" ></div>
                            <div className="col-12 col-sm-12 col-md-1 col-lg-1" ></div>
                            <div className="col-12 col-sm-12 col-md-10 col-lg-10" >
                                <div className='div-contacto-profesional-note'>
                                    <p className='p-label-info-text'>Instagram:</p>
                                    <div className='div-contacto-profesional-note-hijo'>
                                        {
                                            activaInstagram ?
                                                <>
                                                    <input type="text" name='cotactoProfesional2' className={cotactoProfesional2Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                                        value={cotactoProfesional2} onChange={changeInput} />
                                                </>
                                                :
                                                <>
                                                    <input type="text" name='cotactoProfesional2' className={cotactoProfesional2Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                                        value={cotactoProfesional2} onChange={changeInput} disabled />
                                                </>
                                        }
                                        <div className={activaInstagram ? "div-slide-padre-active" : "div-slide-padre"} onClick={() => setActivaInstagram(!activaInstagram)} >
                                            <div className={activaInstagram ? "div-slide-hijo-active" : "div-slide-hijo"}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-1 col-lg-1" ></div>
                            <div className="col-12 col-sm-12 col-md-1 col-lg-1" ></div>
                            <div className="col-12 col-sm-12 col-md-10 col-lg-10" >
                                <div className='div-contacto-profesional-note'>
                                    <p className='p-label-info-text'>Linkedin:</p>
                                    <div className='div-contacto-profesional-note-hijo'>
                                        {
                                            activaLinkedin ?
                                                <>
                                                    <input type="text" name='cotactoProfesional3' className={cotactoProfesional3Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                                        value={cotactoProfesional3} onChange={changeInput} />
                                                </>
                                                :
                                                <>
                                                    <input type="text" name='cotactoProfesional3' className={cotactoProfesional3Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                                                        value={cotactoProfesional3} onChange={changeInput} disabled />
                                                </>
                                        }
                                        <div className={activaLinkedin ? "div-slide-padre-active" : "div-slide-padre"} onClick={() => setActivaLinkedin(!activaLinkedin)} >
                                            <div className={activaLinkedin ? "div-slide-hijo-active" : "div-slide-hijo"}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-1 col-lg-1" ></div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 my-4" >
                                <div className=''>
                                    <p className='p-label-info-text'>Descripción profesional / Bio</p>
                                    <textarea className='form-control' name='observaciones' rows={4} cols={30} placeholder="Cuéntale a tus clientes quién eres, tu experiencia y estilo de trabajo…" />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 my-2" >
                                <div className='div-button-update-info-profesional'>
                                    <button className='bottom-custom-secondary' onClick={() => { }} >
                                        <FontAwesomeIcon icon={faPenSquare} /> Actualizar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                )
            default:
                return (
                    <></>
                )
        }

    }

    return (
        <div className="div-container-db-info-profesional">

            {
                slectVistaEditarInfoProfesional()
            }
        </div>
    );
}

export default InfoProfesional;